const Legal = [
  {
    url: 'controlling-terms',
    app: '5f385208916d230a6bdf43a3'
  },
  {
    url: 'definitions',
    app: '5f384f9d916d230a6bdf43a1'
  },
  {
    url: 'partner/advocate/agreement',
    app: '5f5a330c014f57074bd5e017'
  },
  {
    url: 'platform/terms',
    app: '5f385275916d230a6bdf43a4'
  },
  {
    url: 'platform/connect/terms',
    app: '5f385453916d230a6bdf43a5'
  },
  {
    url: 'privacy',
    app: '5f3841ce916d230a6bdf439f'
  },
  {
    url: 'professional-services/agreement',
    app: '5f38554b916d230a6bdf43a6'
  },
  {
    url: 'terms',
    app: '5f3843f7916d230a6bdf43a0'
  },
];
export default Legal;
